import {
  GET_RECIPIENT_REGISTER_DATA,
  GET_UPDATE_RECIPIENT_REGISTER_DATA,
  GET_SEARCH_ZIPCODE_REGISTER_DATA
} from 'store/constants'


export function getRecipientRegister(values) {
  return {
    type: GET_RECIPIENT_REGISTER_DATA,
    payload: values,
  }
}

export function updateRecipientRegister(values) {
  return {
    type: GET_UPDATE_RECIPIENT_REGISTER_DATA,
    payload: values,
  }
}

export function searchZipCodeRegister(values) {
  return {
    type: GET_SEARCH_ZIPCODE_REGISTER_DATA,
    payload: values,
  }
}

